export const deprecatedDropdownCssClassNames = {
    button: 'Dropdown-button',
    menu: 'Dropdown-menu',
    menuWrapper: 'Dropdown-menuWrapper',
    menuList: 'Dropdown-menuList',
    menuItem: 'Dropdown-menuItem'
};
